import { PageHeader, Loader, EmptyState } from "@/components/common/Loader";
import { useFetch } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

export default function AuditLog() {
  const { data, loading } = useFetch("/admin/audit");
  return (
    <div>
      <PageHeader eyebrow="Super Admin" title="Registro attività" subtitle="Chi ha approvato, caricato, modificato o cancellato cosa, e quando." />
      {loading && !data ? <Loader /> : !data?.length ? <EmptyState title="Nessuna attività registrata" /> : (
        <div className="lux-card divide-y divide-warm/30" data-testid="audit-list">
          {data.map((a) => (
            <div key={a.id} data-testid={`audit-row-${a.id}`} className="px-5 py-4 grid sm:grid-cols-[180px_200px_1fr] gap-1 sm:gap-6">
              <span className="text-xs text-warm-text">{fmtDateTime(a.created_at)}</span>
              <span className="text-sm truncate">{a.actor_name || a.actor_email}</span>
              <span className="text-sm text-warm-text break-words">{a.summary}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
